 <!--美疗师首页-->
 <template>
    <div>
        <div class="remind-box">
            <div class="remind-content flex-y-center" @click="toBookingToStore()">
                <span class="remind-text">今日预约数量</span>
                <span class="nursing-records">{{nursingData.bookingDay}}</span>
                <img class="nursing-arrow" referrerpolicy="no-referrer"
                    src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" alt="" />
            </div>
        </div>
        <div class="briefing-box  flex-row">
            <img class="briefing-img" referrerpolicy="no-referrer"
                src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2023-02-07/nursinglog.png" alt="" />
            <div class="briefing-title">护理日志</div>
            <div class="briefing-title-remark flex-1">(仅统计7日内数据)</div>
            <div class="no-fill"> 未填写：</div>
            <div class="no-fill-number">{{nursingData.nurseNum}}</div>
        </div>
        <div class="nursing-list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                <!-- <van-list v-model="loading" :finished="finished" :loading="loading" @load="onLoad" :offset="20" :immediate-check="false"> -->
                <div class="nursing-moudle" v-if="nursingList.length != 0">
                    <div class="nursing-list" v-for="item,index in nursingList" :key="index"
                        @click="toDetail(item.custId,item.custMobile)">
                        <div class=" flex-between flex-y-center ">
                            <!-- <div class="img-box"> -->
                            <img class="customer-head-portrait" referrerpolicy="no-referrer" alt=""
                                :src="item.avatar?item.avatar:'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                            <!-- </div> -->
                            <div class=" customer-info flex-col flex-1">
                                <span class="customer-name">{{item.custName}}</span>
                                <span class="customer-time">{{item.createDate}}</span>
                            </div>
                            <div class="nursing-edit-box flex-row">
                                <div class="fill-tags">未填写</div>
                                <img class="nursing-edit" @click.stop="toEditDiary(item)" referrerpolicy="no-referrer" alt=""
                                    src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/edit.png" />
                            </div>
                        </div>
                        <div class="billing-advisor">开单顾问：{{item.counselorName}}</div>
                    </div>
                </div>
                <div v-else-if="nursingList.length == 0&&loading==false" class="flex flex-col flex-y-center">
                    <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" alt=""
                        class="empty-icon" />
                    <div class="empty-txt">护理日志都填写完啦～</div>
                </div>
                <!-- </van-list> -->
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";

export default {
    components: {},
    data() {
        return {
            page: 1,
            loading: false,    //加载
            finished: false,    //结束加载
            refreshing: false,   //刷新
            limit: 10,       //每页多少条
            nursingData: [],
            nursingList: [],
        };
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        onLoad() {
            // this.nursingList = [];
            request({
                url: '/home/beautyIndex',
                method: "get",
            })
                .then((res) => {
                    this.nursingData = res.data;
                    this.nursingList = res.data.nursingRemarkDTOList;
                    // this.nursingList = this.page == 1 ? res.data.nursingRemarkDTOList : this.nursingList.concat(res.data.nursingRemarkDTOList);
                    // this.page += 1;
                    // if (res.data.nursingRemarkDTOList.length < this.limit) {
                    //     this.finished = true;
                    // }
                }).catch((error) => {
                    // this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    // this.loading = false;
                    this.refreshing = false
                });
        },
        onRefresh() {
            this.page = 1
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.nursingList = [];
            this.refreshing = false;
            this.onLoad();
        },

        //编辑护理日志
        toEditDiary(item) {
            this.$router.push({ name: "editDiary", query: { data: JSON.stringify(item) } });
        },
        //跳转预约到店
        toBookingToStore() {
            this.$router.push({ name: "bookingToStore", query: {} });
        },
        //顾客详情页
        toDetail(custId, phone) {
            this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
        },
    },
};
</script>

<style scoped lang="less">
::-webkit-scrollbar {
    display: none;
}
.remind-box {
    height: 80px;
    background-color: rgba(250, 250, 254, 1);
    // margin-top: 32px;
}

.remind-content {
    margin: 0 0 0 30px;
}

.remind-text {
    color: rgba(53, 67, 76, 1);
    font-size: 26px;
    line-height: 37px;
}
.nursing-edit {
    width: 34px;
    height: 34px;
    margin-top: 6px;
}

.briefing-box {
    // margin: 0 30px 0 30px;
    padding: 30px;
}
.briefing-img {
    width: 40px;
    height: 40px;
    display: block;
    margin-top: 28px;
}
.briefing-title {
    color: rgba(53, 67, 76, 1);
    font-size: 34px;
    text-align: left;
    margin: 24px 0 0 10px;
    font-weight: 700;
}
.nursing-records {
    font-size: 34px;
    color: #f65252;
    // line-height: 48px;
    margin: 0 0 0 20px;
}
.nursing-arrow {
    width: 16px;
    height: 28px;
    margin: 26px 0 26px 478px;
}
.briefing-title-remark {
    min-width: 214px;
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    // margin: 60px 0 0 10px;
    margin: 30px 0 0 10px;
}
.no-fill {
    height: 45px;
    font-size: 26px;
    color: #66757f;
    line-height: 37px;
    // margin: 56px 0 0 144px;
    margin: 25px 0 0 0;
}
.no-fill-number {
    height: 45px;
    color: rgba(246, 82, 82, 1);
    font-size: 32px;
    line-height: 37px;
    margin-top: 26px;
}
.fill-tags {
    width: 104px;
    height: 46px;
    background: #ff8519;
    border-radius: 23px;
    text-align: center;
    font-size: 26px;
    color: #ffffff;
    line-height: 37px;
    padding: 4px;
}

.nursing-list-box {
    padding-bottom: 100px;
}
.nursing-list {
    width: 690px;
    height: 238px;
    background: #ffffff;
    box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
    border-radius: 30px;
    margin-bottom: 20px;
}

.customer-head-portrait {
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin: 30px 0 0 19px;
}
.customer-info {
    margin: 0 0 0 20px;
}
.customer-name {
    height: 42px;
    font-size: 30px;
    color: #35434c;
    line-height: 42px;
    margin-top: 30px;
    font-weight: 700;
}
.customer-time {
    // width: 200px;
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    margin-top: 11px;
}
.nursing-moudle {
    padding: 15px 30px 30px 30px;
}
.nursing-edit-box {
    margin: 0 30px 0 0;
}
.nursing-edit {
    width: 34px;
    height: 34px;
    margin-left: 30px;
}
.billing-advisor {
    min-width: 224px;
    height: 40px;
    font-size: 28px;
    color: #35434c;
    line-height: 40px;
    margin: 32px 0 0 19px;
}
.empty-txt {
    width: 329px;
    height: 45px;
    font-size: 32px;
    color: #35434c;
    line-height: 45px;
}
.empty-icon {
    width: 280px;
    height: 280px;
    margin-top: 151px;
}
</style>
